const images = require.context('../../images', true)
const imagePath = (name) => images(name, true)

var componentRequireContext = require.context("components", true)
var ReactRailsUJS = require("react_ujs")
ReactRailsUJS.useContext(componentRequireContext)

window.addEventListener('load', () => {
    
})